<div class="bg-col-35 p-l p-r p-t-2 p-b-2">
    <p class="s1 center-m center-s">{{'Some items are out of stock, remove to checkout' | translate}}</p>
    <div class="flex flex-middle flex-justify-center">
        <i class="icon-trash"></i>
        <action class="p2 m-l-1 cursor-pointer"
                [status]="status"
                (click)="removeOOSProducts()">{{'Remove all out of stock items from bag' | translate}}</action>
    </div>
</div>
